import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, DeviceFullDTO } from '../../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../../services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { TableWrapperOptions } from '../../../../services/global/global-interfaces';
import { PermissionService } from '../../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-comp-channel-devices',
  templateUrl: './channel-devices.component.html',
  styleUrls: ['./channel-devices.component.scss'],
  standalone: false,
})
export class ChannelDevicesComponent implements OnInit {
  channelId: number;
  loading: boolean;
  devices: DeviceFullDTO[];
  debounceTimer: ReturnType<typeof setTimeout>;
  options: TableWrapperOptions;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.debounceTimer = null;
    this.channelId = undefined;
    this.devices = [];
    this.loading = true;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.channelId = +params.channelID;
    });
  }

  getChannelId() {
    const arr: number[] = [];
    arr.push(this.channelId);
    return JSON.stringify(arr);
  }

  requestDebounced(options?: TableWrapperOptions) {
    if (options) {
      this.options = options;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    if (this.channelId && this.options?.pagination) {
      this.loading = true;
      this.api
        .ss_nm_Device_retrieveAll(
          {
            search: this.util.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
            channel: [this.channelId],
          },
          this.options.pagination
        )
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (res: DeviceFullDTO[]) => {
            this.devices = res;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
